"use strict";
/**
 * Everything needed to implement your own provider.
 */
Object.defineProperty(exports, "__esModule", { value: true });
